define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-construct",
	"dojo/query",
	"csi",
	"csi/_base/underscore",
	"csi/gallery/Widget",
	"csi/html",
	"csi/xml",
	"Specification"
], function(declare,lang,domClass,domConstruct,query,csi,_,Widget,html,xml,Specification) {

	return declare(Widget, {
		canAggregatePlacement: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: only allow selection of PartMaterial nodes (not dividers)
			return ctx.getNode().$Type == "PartMaterial";
		},

		_onRootDependencyPaths: function(/*String[]*/paths) {
			// summary: add own paths - Headings and Images are already taken care of, so skip them
			if (this.defView.isReadOnly()) {
				paths.push("Child:BOMLanguages");
			}

			this.inherited(arguments);
		},

		_getPlacementMap: function() {
			// summary: create mapping of placement nodes
			var	admin = this.cacheView.getNode(Specification.URL_ADMIN, true);
			var	placements = this.cacheView.getChildren(admin, "Placements", true);
			if (!placements || !placements.length) return null;

			var	obj = {};

			_.each(placements, function(node) {
				obj[node.$Name] = node;
			});

			return obj;
		},

		_postView: function() {
			// summary: duplicate block for each language in BOM languages if in BOM view
			if (!this.isValidView(true)) {
				return null;
			}

			if (this.defView.isReadOnly()) {
				// change refNodes from being each composition to instead being each language block of all compositions
				var	cache = this.cacheView;
				var	parentNode = this.getContentRoot();
				var	blockNode = domConstruct.create("div", {"class":"csiBomCompositionLanguage"});
				var	refNodes = this.getRefNodes();

				refNodes.forEach(this._removeBlockStyling, this);
				refNodes.wrapAll(blockNode);
				this._addBlockStyling(blockNode);

				// copy block for each language
				var	languages = this.cacheView.getNodes(this.getViewNode().BOMLanguages);
				if (languages && languages.length) {
					// put in correct order and then extract names
					languages = _.map(csi.sort(languages, "SortOrder"), xml.nodeGetSysID, xml);

					// for each language, duplicate composition gallery blocks and substitute with new languages
					var placementMap = this._getPlacementMap();
					var placementNames;
					var s;

					// find placements used in composition
					if (placementMap) {
						placementNames = query(".headingName", blockNode).map(function(e) {
							return e.innerText;
						});
					}

					// find materials used in composition
					var materials = query(".headingComp", blockNode).map(function(e) {
						return cache.getNode(html.getElementContext(e, true));
					});

					_.each(languages, function(lng) {
						var copyNode = blockNode.cloneNode(true);
						parentNode.appendChild(copyNode);

						if (placementMap) {
							query(".headingName", copyNode).forEach(function(e, i) {
								var	pname = placementNames[i];
								var	pnode = placementMap[pname];

								if (s = pnode ? Specification.getTranslation(pnode, lng) : pname) {
									html.setInnerText(e, s);
								}
							});
						}

						query(".headingComp", copyNode).forEach(function(e, i) {
							if (s = Specification.getMaterialComposition(materials[i], cache, lng)) {
								html.setInnerText(e, s);
							}
						});
					}, this);
				}
			}

			this.inherited(arguments);
		}
	});
});